module.exports = __webpack_public_path__ + "img/shengganQR.bfdd9384.png";